/**
 * Comprehensive Disposable / Temporary Email Detector.
 * Blocks temp mail services, throwaway inboxes, and burner email providers.
 */

const DISPOSABLE_KEYWORDS = [
  'tempmail', 'temp-mail', 'tempail', 'tempm', 'temppost', 'temporary',
  'disposable', 'throwaway', 'trashmail', 'trash-mail', 'trashemail',
  'guerrillamail', 'guerillamail', 'sharklasers', 'grr.la', 'pokemail',
  'mailinator', 'mailin8r', 'suremail', 'safetymail', 'trashymail',
  'yopmail', 'jetable', 'courriel', 'moncourrier', 'monemail', 'monmail',
  'getnada', 'nada.ltd', 'nada.email', 'dropmail', 'dispostable',
  'fakeinbox', 'fakemail', 'fakermail', 'emailondeck', 'generator.email',
  'crazymailing', 'crazymail', 'mohmal', 'burnermail', 'inboxkitten',
  'maildrop', 'harakirimail', '10minutemail', '10minemail', '10mail', '20mail',
  '30minutemail', '60minutemail', 'minutemail', 'spam4', 'spambox', 'spamavert',
  'spambob', 'spambog', 'spamfree', 'spamgourmet', 'spamhole', 'spammotel',
  'anonbox', 'anonymbox', 'wegwerf', 'dayrep', 'teleworm', 'armyspy',
  'cuvox', 'einrot', 'fleckens', 'gustr', 'jourrapide', 'rhyta', 'superrito',
  'binkmail', 'bobmail', 'chammy', 'devnullmail', 'letthemeatspam',
  'zillamail', 'zippymail', 'mytemp', 'tempemail', 'fake-mail', 'email-fake',
  'dummy', 'fake', 'testmail', 'testinbox', 'testemail', 'demomail'
];

const DISPOSABLE_DOMAINS = new Set([
  'mailinator.com', 'mailinator.net', 'mailinator.org', 'mailinator2.com', 'mailin8r.com',
  'tempmail.com', 'temp-mail.org', 'temp-mail.io', 'tempmail.net', 'tempmailaddress.com', 'tempmail.ninja',
  'tempmail.plus', 'tempail.com', 'tempmailgen.com', 'tempm.com', 'tempinbox.com', 'tempmailo.com',
  '10minutemail.com', '10minutemail.net', '10minemail.com', '10minutemail.co.za', '10minutemailbox.com',
  '10mail.org', '20mail.it', '20mail.eu', 'minutemail.com', '33mail.com', 'burnermail.io',
  'guerrillamail.com', 'guerrillamail.net', 'guerrillamail.org', 'guerrillamail.biz', 'guerrillamailblock.com',
  'sharklasers.com', 'grr.la', 'pokemail.net', 'spam4.me', 'getairmail.com', 'dispostable.com',
  'yopmail.com', 'yopmail.fr', 'yopmail.net', 'cool.fr.nf', 'jetable.fr.nf', 'courriel.fr.nf',
  'moncourrier.fr.nf', 'monemail.fr.nf', 'monmail.fr.nf', 'mega.zik.dj', 'speed.1s.fr', 'nospam.ze.tc',
  'throwawaymail.com', 'throwaway.email', 'trashmail.com', 'trashmail.net', 'trashmail.me', 'trashmail.io',
  'trashmail.ws', 'rcpt.at', 'damnthespam.com', 'getnada.com', 'nada.ltd', 'nada.email', 'inboxbear.com',
  'clrmail.com', 'dropmail.me', 'fakeinbox.com', 'fakemailgenerator.com', 'emailondeck.com', 'generator.email',
  'crazymailing.com', 'crazymail.com', 'fakemail.net', 'mohmal.com', 'mohmal.in', 'mohmal.im',
  'mytemp.email', 'mytempemail.com', 'inboxkitten.com', 'maildrop.cc', 'harakirimail.com',
  'dayrep.com', 'teleworm.us', 'armyspy.com', 'cuvox.de', 'einrot.com', 'fleckens.hu',
  'gustr.com', 'jourrapide.com', 'rhyta.com', 'superrito.com', 'binkmail.com', 'bobmail.info',
  'chammy.info', 'devnullmail.com', 'letthemeatspam.com', 'notmailinator.com', 'reconmail.com',
  'spambox.us', 'spamherelots.com', 'tradermail.info', 'veryrealemail.com', 'zillamail.com',
  'zippymail.info', 'chacuo.net', 'mailsac.com', 'mailnull.com', 'mailscrap.com', 'mailshell.com',
  'mailslurp.com', 'mailslurp.net', 'mailtemp.net', 'mailtothis.com', 'mailtrash.net',
  'easytrashmail.com', 'eintagsmail.de', 'email-fake.com', 'email-temp.com', 'email60.com',
  'filzmail.com', 'fiveminuteemail.com', 'fixmail.biz', 'flemail.ru', 'flyspam.com',
  'garbagemail.org', 'hidemail.de', 'incognitomail.com', 'instantemailaddress.com', 'instantmail.org',
  'kasmail.com', 'kaspost.com', 'killmail.net', 'laste.ml', 'lazyinbox.com', 'litedrop.com',
  'mail4trash.com', 'mailbidon.com', 'mailcatch.com', 'maileater.com', 'mailexpire.com',
  'mailforspam.com', 'mailfreeonline.com', 'mailhazard.com', 'mailhazard.us', 'mailnesia.com',
  'meltmail.com', 'mintemail.com', 'mytrashmail.com', 'noclickemail.com', 'nomail.xl.cx',
  'nowmymail.com', 'oneoffemail.com', 'onewaymail.com', 'owlymail.com', 'pookmail.com',
  'postinbox.com', 'quickinbox.com', 'rejectmail.com', 's0ny.net', 'shieldemail.com',
  'shiftmail.com', 'shortmail.net', 'slopsbox.com', 'sofort-mail.de', 'sogetthis.com',
  'spamavert.com', 'spambob.com', 'spambog.com', 'spambog.de', 'spamex.com',
  'spamfree24.com', 'spamfree24.de', 'spamgourmet.com', 'spamhole.com', 'spaml.com',
  'spammotel.com', 'tagmail.com', 'tafmail.com', 'targetmail.com', 'tempthe.net',
  'thankyou2010.com', 'thisisnotmyrealemail.com', 'throwawayemailaddress.com', 'trash-area.com',
  'trash-mail.at', 'trash-mail.ch', 'trash-mail.com', 'trash-mail.de', 'trashbox.eu',
  'trashcanmail.com', 'trashdelivery.com', 'trashemail.de', 'trashemail.net', 'trashinbox.com',
  'trashmail.at', 'trashmail.ch', 'trashmail.de', 'trashmail.eu', 'trashmail.fr',
  'trashmail.org', 'trashmailer.com', 'trashymail.com', 'trbvm.com', 'trbvn.com',
  'u4e.net', 'ubomail.com', 'umail.net', 'uroid.com', 'vanityemail.com',
  'walkmail.net', 'wegwerf-email.net', 'wegwerfadresse.de', 'wegwerfemail.com',
  'wegwerfemail.de', 'wegwerfmail.de', 'wegwerfmail.net', 'whyspam.me',
  'willselfdestruct.com', 'wmail.be', 'wuzup.net', 'wuzupmail.net', 'x-mail.net.tc',
  'xagloo.com', 'xemaps.com', 'xmaily.com', 'yapped.net', 'youspam.org',
  'zaubermail.com', 'zehnminutenmail.de', 'zoemail.com', 'zomg.info',
  'example.com', 'example.org', 'example.net', 'example.edu',
  'test.com', 'testing.com', 'testmail.com', 'testemail.com', 'testinbox.com',
  'demo.com', 'demomail.com', 'demoemail.com', 'fake.com', 'fakemail.com',
  'sample.com', 'samplemail.com', 'invalid.com', 'dummy.com', 'dummymail.com',
  'none.com', 'nomail.com', 'asdf.com'
]);

/**
 * Checks whether an email address uses a temporary / disposable email domain.
 * @param {string} email
 * @returns {boolean} true if disposable/temporary, false if valid permanent email.
 */
export function isDisposableEmail(email) {
  if (!email || typeof email !== 'string') return false;
  const trimmed = email.trim().toLowerCase();
  const atIndex = trimmed.lastIndexOf('@');
  if (atIndex === -1 || atIndex === trimmed.length - 1) return false;

  const domain = trimmed.slice(atIndex + 1);
  if (!domain || domain.indexOf('.') === -1) return false;

  // 1. Direct domain match
  if (DISPOSABLE_DOMAINS.has(domain)) {
    return true;
  }

  // 2. Subdomain check (e.g. sub.yopmail.com)
  for (const known of DISPOSABLE_DOMAINS) {
    if (domain.endsWith('.' + known)) {
      return true;
    }
  }

  // 3. Keyword heuristic on domain parts
  const domainParts = domain.split('.');
  for (const part of domainParts) {
    for (const kw of DISPOSABLE_KEYWORDS) {
      if (part.includes(kw)) {
        return true;
      }
    }
  }

  return false;
}
